import { useMemo } from 'react';

export function useWarehouseName(location: string | null | undefined) {
    return useMemo(() => `${location}`, [location]);
}
